import { Injectable } from '@angular/core';
import { InjectConfig, IqConfigKey } from '@ddt-web/config-layer';
import { PasFeature } from '@ddt-web/data-service';
import { ErrorObject } from '@ddt-web/error-handler';
import { AssetResolveResponse, PasApiService, PasPortfolioPosition } from '@ddt-web/pas';
import { Store } from '@ngrx/store';

import { partialSecurityFailing } from '../../../store/data-loading.actions';
import { PasPostProcessingService } from './pas-post-processing.service';


/**
 * Service that processes the partial securities missing for asset-resolve API response for IQ.
 * The service throws an error with the response.
 * This needs to be done as last step in post-processing so it does not interrupt any other processes (updating store with valid securities etc)
 */
@Injectable()
export class PasPartialSecurityFailingProcessingService extends PasPostProcessingService {
	@InjectConfig(IqConfigKey.ENABLE_FUND_STATUS_INTERACTIONS) private readonly isFundStatusInteractionsEnabled = false;

	constructor(private store: Store) {
		super();
	}

	public process(
		portfoliosToLoad: PasPortfolioPosition[],
		filteredIds?: string[],
		positionDataFromApiCall?: AssetResolveResponse,
		feature?: PasFeature,
		store: string = PasApiService.POSITION_DETAILS_CONFIG_NAME
	): void {
		if (positionDataFromApiCall.errorCodes) {
			let configName;

			switch (feature) {
				case PasFeature.COMPARE:
					configName = PasApiService.COMPARE_CONFIG_NAME;
					break;
				case PasFeature.WORST_TAX_OFFENDERS:
					configName = PasApiService.TAX_DETAILS_CONFIG_NAME;
					break;
				default:
					configName = store;
					break;
			}

			if (configName === PasApiService.POSITION_DETAILS_CONFIG_NAME && this.isFundStatusInteractionsEnabled) {
				// action is dispatched to trigger cleanUpFundStatusInteractionsForMissingFunds$ effect
				this.store.dispatch(partialSecurityFailing({ payload: positionDataFromApiCall.errorCodes }));
			}

			throw new ErrorObject(positionDataFromApiCall, configName);
		}
	}
}
